import React from 'react'

const StepperButtonPlus = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <circle cx={16} cy={16} r={16} fill="currentColor" />
    <path d="M11 16.5V15h4v-4h1.6v4h4v1.5h-4v4H15v-4h-4z" fill="#fff" />
  </svg>
)

export default StepperButtonPlus
